import { OWebPageBase } from "oweb";
import PAccountComponent from "@/components/pages/PAccount.vue";
import { VueConstructor } from 'vue';


export default class PAccount extends OWebPageBase<VueConstructor> {
	getName() {
		return "PAccount"
	}

	requireLogin() {
		return true
	}

	getRoutes() {
		return [ {
			title: "SX_LANG_ACCOUNT",
			slug: "w-account-menu",
			path: "/account"
		}, {
			title: "SX_LANG_ACCOUNT",
			slug: "w-account-edit",
			path: "/account/edit"
		}, {
			title: "SX_LANG_ACCOUNT",
			slug: "w-account-edit-pass",
			path: "/account/edit/pass"
		}, {
			title: "SX_LANG_COMPANY_ADD",
			slug: "w-company-add",
			path: "/companies/add"
		}, {
			title: "SX_LANG_SECTOR_ADD",
			slug: "w-sector-add",
			path: "/sectors/add"
		} ]
	}

	getComponent() {
		return PAccountComponent;
	}
}
